<script>
  import { orbit_3d, fade_text } from '#lib/transitions.js';
  import { getContext } from 'svelte';
  let site_settings = getContext('site_settings');

  let { 
    /** @type {string} name of the user, used to generate the initials */
    name = '', 
    /** @type {string} class of the avatar */
    class: css_class = '',
    /** @type {boolean} animate the avatar */
    animate = false,
  } = $props();

  let initials = $derived(get_initials(name));

  function get_initials(name) {
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  }

</script>

<div class="avatar avatar-initials button-icon {css_class} {site_settings.primary_control_surface}">
  {#key name}
    <div 
      class="avatar-visual" 
      in:orbit_3d|local={{...!animate ? {duration: 0} : {}}}
    >
      <svg viewBox="0 0 40 40" width="100%" height="100%">
        <circle cx="20" cy="20" r="19" />
        <text 
          x="50%" 
          y="50%" 
          text-anchor="middle" 
          dominant-baseline="central"
          class="initials-text text-control"
          in:fade_text|local={{...!animate ? {duration: 0} : {}}}
        >
          {initials}
        </text>
      </svg>
    </div>
  {/key}
</div>

<style lang="postcss">
  .avatar {
    position: relative;
    display: inline-block;
    min-width: var(--avatar-size);
    min-height: var(--avatar-size);
    aspect-ratio: 1;
    height: auto;
    perspective: 1000px;
    border-radius: var(--round);
    .avatar-visual {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      transform-style: preserve-3d;
      backface-visibility: visible;
      svg {
        aspect-ratio: 1;
        height: auto;
      }
      
      /* Style inheritance for SVG text */
      text.initials-text {
        letter-spacing: inherit;
        line-height: inherit;
        transform: translateZ(1px);
      }
    }

    &:is(.encased, .filled, .elevated) {
      circle {
        fill: var(--avatar-fill, var(--color-default-emphasis-background));
      }
      .initials-text {
        fill: var(--color-default-emphasis-foreground);
      }
    }
    &:not(:is(.encased, .filled, .elevated)) {
      circle {
        fill: var(--color-default-background);
      }
      .initials-text {
        fill: var(--color-default-foreground); 
      }
    }
    &:is(.encased, .outlined, .underlined) {
      circle {
        stroke: var(--color-default-stroke);
        stroke-width: 1;
      }
    }
  }
</style>